export default __webpack_public_path__ + "static/media/Punto_07_Il_Pontino_DEU_Def.9df10a4f.aac";